import React, {Component} from "react"
import {Button, Icon, Table, Row, Pagination} from "antd"
import "./Index.scss"
import Lightbox from "react-image-lightbox"
import config from "app/config"
import downloadIcon from "app/styles/images/sp/download.svg"
import { observer, inject } from 'mobx-react'
import PushModal from './PushModal'
import cx from 'classnames'
import { PREPARE_RUN, RUNNING } from 'app/utils/const'
import pushIcon from 'app/styles/images/sp/push.svg'

const columnsReport = [{
  title: "chromosome",
  dataIndex: "chromosome",
  width: 150
}, {
  title: "Average",
  dataIndex: "average",
  width: 150
}, {
  title: "Aneuploidy",
  dataIndex: "aneuploidy"
}, {
  title: "position",
  dataIndex: "position"
}]
const columnsNewReport = [
  {
    title: "chromosome",
    dataIndex: "chromosome",
    width: 200
  }, {
    title: "Median",
    dataIndex: "average",
    width: 200
  }, {
    title: "Aneuploidy(mosaic)",
    dataIndex: "aneuploidy"
  }
]

@inject('auth')@observer
export default class ReportDetail extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false,
      activeReportIndex: 0,
      currentPage:1,
      reportListArr:[],
      pushModalShowed: false,
    }
  }

  onCloseRequest() {
    this.state = {
      isOpenImg1: false,
      isOpenImg2: false
    }
  }

  showModal = (field) => {
    this.setState({
      [field]: true
    })
  }

  closeModal = (cb) => {
    this.setState({
      pushModalShowed: false,
    })
  }

  isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.index !== this.props.index) {
      this.initNav(nextProps.index)
    }
  }

  componentWillMount() {
    this.initNav(this.props.index)
  }

  initNav = (index) => {
    this.setState({
      activeReportIndex: index,
      currentPage: Math.floor(index / 10) + 1
    })
  }

  buttonClick = (template,id) => window.open(`${config.backend}/pgs/reports/preview/${id}?templateId=${template}`)

  changeReport = (index, record) => {
    this.refs.content.scrollTop = 0
    this.setState({
      activeReportIndex:index
    })
    this.props.dataSwitch(index, record)
  }

  changePage = (e) => {
    let activeReportIndex = (e-1) * 10
    let record = this.props.reportList[activeReportIndex]

    this.renderReportList(e)
    this.setState({
      currentPage:e,
      activeReportIndex
    })
    this.changeReport(activeReportIndex, record)
  }

  renderReportList = (pageNumber) => {
    let { reportList } = this.props.data
    let { pushModalShowed } = this.state
    let reportListArr = []
    let endNum = pageNumber * 10

    if (endNum > reportList.length) {
      endNum = reportList.length
    }
    for (let currenNum = (pageNumber - 1) * 10; currenNum < endNum; currenNum++) {
      const { state } = reportList[currenNum]
      const liClass = cx({
        'report cursor-p': true,
        'active': this.state.activeReportIndex === currenNum,
        'disabled': pushModalShowed
      })

      if (state !== PREPARE_RUN && state !== RUNNING) {
        reportListArr.push(
          <li
            key={currenNum}
            onClick={() => {
              if (!pushModalShowed) {
                this.changeReport(currenNum, reportList[currenNum])
              }
            }}
            className={liClass}
          >
            {reportList[currenNum].sampleName}
          </li>
        )
      }
    }
    return reportListArr
  }

  renderResultGender = (detailData) => {
    if(detailData.resultGender !== '') {
      return (
        <li className='resultDetailText'>{detailData.resultGender}</li>
      )
    }else {
      return ''
    }
  }

  renderResultAneu = (detailData) => {
    if(detailData.resultAneu !== '') {
      const resultAneu = detailData.resultAneu.split(';').join('; ').split(' ')
      return (
        resultAneu.map(item => {
          return (
            <li className='resultDetailText'>{item}</li>
          )
        })
      )
    }else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }

  renderResultCNV = (detailData) => {
    if (detailData.resultCNV !== '') {
      const resultCNV = detailData.resultCNV.split(';').join('; ').split(' ')
      return (
        resultCNV.map(item => {
          return (
            <li className='resultDetailText'>{item}</li>
          )
        })
      )
    }else {
      return (
        <li className='resultDetailText'>未见异常</li>
      )
    }
  }

  renderResultM = (detailData) => {
    if(detailData.resultM !== '') {
      return (
        <li className='resultDetailText'>{detailData.resultM}</li>
      )
    }else {
      return ''
    }
  }

  render() {
    const {
      isOpenImg1,
      isOpenImg2,
      currentPage,
      pushModalShowed,
    } = this.state
    let {
      data = {},
      detailData,
      templates,
      groupId,
      auth: { pushAuth = {} },
    } = this.props
    let columnsData = []
    if (data.reportList === undefined) {
        data.reportList = []
    } else {
      if(!this.isEmptyObj(detailData) && detailData["statistical"]){
        columnsData = [
          {
            title: "Total_Reads",
            dataIndex: "Total_Reads",
            width: 150,
            className: "DataContent"
          },
          {
            title: "MT_ratio(%)",
            dataIndex: "MT_ratio(%)",
            width: 150,
            className: "DataContent"
          },
          {
            title: "Map_Ratio(%)",
            dataIndex: "Map_Ratio(%)",
            width: 150,
            className: "DataContent"
          },
          {
            title: "Duplicate(%)",
            dataIndex: "Duplicate(%)",
            width: 150,
            className: "DataContent"
          },
          {
            title: "GC_Count(%)",
            dataIndex: "GC_Count(%)",
            width: 150,
            className: "DataContent"
          },
          {
            title: "*SD",
            dataIndex: "*SD",
            width: 150,
            className: "DataContent"
          }
        ]
      }
    }

    return (
      <Row type="flex" className="pgs-report-detail">
        <div ref="content" className="content">
          <div id="detailTop" className="detail-card border-left-paimary first">
            <div className="pull-right">
              {templates !== undefined ? templates.map((item) => {
                if(item.type === "data" && item.format === "html" && item.appGroupName === data.appGroupName){
                  return  (
                    <Button key={item.id+"html"}
                      type="primary" size="large"
                      onClick={(e) => {this.buttonClick(item.id, detailData.reportId)}}
                    >
                      <Icon type="book"/>
                      打开报告
                    </Button>
                  )
                }else if(item.type === "data" && item.format === "pdf" && item.appGroupName === data.appGroupName){
                  return  <Button key={item.id+"pdf"}
                    type="primary"
                    size="large"
                    onClick={(e) => this.buttonClick(item.id, detailData.reportId)}>
                    <Icon type="file-pdf"/>PDF 下载</Button>
                }else{
                    return ""
                }
              }).filter((item) => item) : ""}
            </div>
            <div className="info-group">
              <label>数据类型：</label>
              <p>{data ? data.appName : ""}</p>
            </div>
            <div className="info-group">
              <label>文件名称：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.dataName : ""}</p>
            </div>
            <div className="info-group">
              <label>所在分组：</label>
              <p>{data.groupName}</p>
            </div>
            <div className="info-group">
              <label>样本名称：</label>
              <p>{!this.isEmptyObj(detailData) ? detailData.sampleName : []}</p>
            </div>
          </div>

          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">数据统计</h3>
            <Table
              columns={columnsData}
              rowKey={record => record.Total_Reads+"statistical"}
              dataSource={!this.isEmptyObj(detailData) ? [].concat(detailData.statistical) : []}
              pagination={false} />
          </div>
          {
            detailData.dataVersion === 'v2.0' && (
              <div>
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">参考信息</h3>
                  <Table columns={columnsNewReport}
                    rowKey={record => record.average + "" + record.chromosome + "" + record.aneuploidy}
                    dataSource={!this.isEmptyObj(detailData) ? detailData.chromosomeRefinfos : []}
                    pagination={false}
                  />
                </div>
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">报告结果</h3>
                  <div className='reportResultWrap'>
                    <ul>
                      <li>
                        <div className='reportResultTitle'><span className='circle'></span>性染色体</div>
                        <ul className='resultDetailList'>
                          {this.renderResultGender(detailData)}
                        </ul>
                      </li>
                      <li>
                        <div className='reportResultTitle'><span className='circle'></span>整倍体</div>
                        <ul className='resultDetailList'>
                          {this.renderResultAneu(detailData)}
                        </ul>
                      </li>
                      <li>
                        <div className='reportResultTitle'><span className='circle'></span>CNV</div>
                        <ul className='resultDetailList'>
                          {this.renderResultCNV(detailData)}
                        </ul>
                      </li>
                      <li>
                        <div className='reportResultTitle'><span className='circle'></span>补充结果</div>
                        <ul className='resultDetailList'>
                          {this.renderResultM(detailData)}
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )
          }
          {
            detailData.dataVersion === 'v1.0' && (
              <div>
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">报告</h3>
                  <Table columns={columnsReport}
                    rowKey={record=>record.average+""+record.chromosome+""+record.aneuploidy}
                    dataSource={!this.isEmptyObj(detailData) ? detailData.chromosomes : []}
                    pagination={false}
                  />
                </div>
                <div className="detail-card">
                  <h3 className="border-left-primary detail-card-title">补充信息</h3>
                  <div>
                    <p>{!this.isEmptyObj(detailData) ? detailData.resultM : "无"}</p>
                  </div>
                </div>
              </div>
            )
          }
          <div className="detail-card">
            <h3 className="border-left-primary detail-card-title">染色体</h3>
            <div>
              <img alt="" src={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromMiniPng : []} />
            </div>
          </div>
          <div className="detail-card">
            <div className="title-wrapper">
              <h3 className="border-left-primary detail-card-title">染色体点图</h3>
              <a
                className="point-link"
                href={
                  `${config.backend}/pgs/reports/${!this.isEmptyObj(detailData) && detailData.reportId}/charts/gc`
                }
              target="_blank">
                精确染色体点图
              </a>
            </div>
            <div>
              <img alt="" className="img-hand"
                src={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromPointPng : []}
                onClick={() => this.setState({isOpenImg1: true})}/>
              {
                isOpenImg1 &&
                <Lightbox mainSrc={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromPointPng : []}
                  onCloseRequest={() => this.setState({isOpenImg1: false})}
                />
              }
            </div>
            <div>
              <img alt="" className="img-hand"
                src={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromPointSplitPng : []}
                onClick={() => this.setState({isOpenImg2: true})} />
              {
                isOpenImg2 &&
                <Lightbox mainSrc={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromPointSplitPng : []}
                  onCloseRequest={() => this.setState({isOpenImg2: false})}
                />
              }
            </div>
          </div>
          <div className="detail-card last">
            <h3 className="border-left-primary detail-card-title">染色体位置图</h3>
            <div>
              <img alt="" src={!this.isEmptyObj(detailData) ? detailData.imgWithXY.chromFinalPng : []}/>
            </div>
          </div>

          <div className="wrapper-download">
            <a
              href={`${config.backend}/pgs/reports/${!this.isEmptyObj(detailData) && detailData.reportId}/download`}
              title="下载报告"
              className="download"
            >
              <img src={downloadIcon} alt="下载"/>
            </a>
          </div>

          {pushAuth.notifyLimsPgs && (
            <div className="wrapper-push">
              <a
                onClick={() => this.showModal('pushModalShowed')}
                title="推送报告"
                className="push"
              >
                <img src={pushIcon} alt="推送"/>
              </a>
            </div>
          )}

        </div>
        <div className="reportNav">
          <div className="title">本组数据</div>
          <ul className="reports">
            {this.renderReportList(currentPage)}
          </ul>
          <Pagination
            className="pagination"
            size="small"
            pageSize={10}
            total={
              data.reportList.filter(item =>
                item.state !== PREPARE_RUN && item.state !== RUNNING
              ).length
            }
            current={currentPage}
            onChange={(e) => {
              if (!pushModalShowed) {
                this.changePage(e)
              }
            }}
          />
        </div>

        {/* {true && ( */}
        {pushModalShowed && (
          <PushModal
            store={this.props.store}
            data={data}
            closeModal={this.closeModal}
            groupId={groupId}
          />
        )}
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/pgs/ReportDetail/index.js